import { render, staticRenderFns } from "./activity-statistics-list.vue?vue&type=template&id=14ff680a&scoped=true&"
import script from "./activity-statistics-list.vue?vue&type=script&lang=js&"
export * from "./activity-statistics-list.vue?vue&type=script&lang=js&"
import style0 from "./activity-statistics-list.vue?vue&type=style&index=0&id=14ff680a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ff680a",
  null
  
)

export default component.exports